var map = {
	"./0.png": 9691,
	"./1.png": 690,
	"./2.png": 5833,
	"./3.png": 4656,
	"./full.png": 516,
	"./online-0.png": 2873,
	"./online-1.png": 6624,
	"./online-2.png": 4267,
	"./online-3.png": 6786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5232;